import { useFlags } from 'launchdarkly-react-client-sdk'
import { useMemo } from 'react'

import { FEATURE_FLAGS } from '@infura/packages.common/constants'

import { trackClickForSegmentAnalytics } from '@infura/packages.common/segmentAnalytics'
import { HeaderBanner } from 'components/banners/HeaderBanner'
import useVisibilityCookie from 'hooks/useVisibilityCookie'

const IPFS_SURVEY_BANNER = 'IPFS_SURVEY_BANNER_KEY'

/**
 * Renders a banner which links to IPFS survey
 */
export const SurveyBanner = () => {
  const [shouldShowBanner, toggleBanner] = useVisibilityCookie(IPFS_SURVEY_BANNER)

  const flags = useFlags()
  const featureFlag = useMemo(() => flags[FEATURE_FLAGS.IPFS_SURVEY_BANNER], [flags])

  if (!featureFlag) {
    return null
  }

  if (!shouldShowBanner) {
    return null
  }

  const text = 'Help us build the future of decentralized storage with IPFS! Fill out a short survey.'
  const link = 'https://forms.gle/LdVxwNnYXUh3pSJY7'

  const handleDismiss = () => {
    toggleBanner()
    trackClickForSegmentAnalytics({
      clickText: 'Dismiss',
      location: 'IPFS Survey Banner',
      type: 'Button'
    })
  }

  const handleClick = () => {
    trackClickForSegmentAnalytics({
      clickText: text,
      clickUrl: link,
      location: 'IPFS Survey Banner',
      type: 'Link'
    })
  }

  return (
    <HeaderBanner link={link} onClick={handleClick} onDismiss={handleDismiss} testId='ipfs-banner-link'>
      {text}
    </HeaderBanner>
  )
}
